import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';

interface IProps extends StateProps, RouteProps {
  requireAuth?: boolean;
}

const RouteWrapper: React.FC<IProps> = ({
  authenticatedUser,
  component: Component,
  requireAuth = false,
  ...rest
}) => {
  if (rest.path === '/actor/vd' && !rest.location.search) {
    requireAuth = true;
  }

  if ( requireAuth && !authenticatedUser) {
    return (<Redirect to="/403" />);
  }

  return (
    <Route component={Component} {...rest} />
  );
};

interface StateProps {
  authenticatedUser: any;
}

const mapStateToProps = (state: any) => ({
  authenticatedUser: state.app.authenticatedUser
});

export default connect(
  mapStateToProps,
  null
)(RouteWrapper);
